// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3Pd2n","list":"styles_list__yHkwg"};